/**
 * Video module
 *
 * This module is used to replace the video iframe src with a data-cookieblock-src. This is to prevent from tracking the user before they have accepted the cookie consent.
 *
 */

export const init = () => {
  const iframeELems = Array.from(document.getElementsByTagName('iframe'));
  const videoservices = ['youtube', 'vimeo', 'dreambroker'];

  /**
   * Checks if iframe url is from external video service
   * @param {string} src iframe src
   * @returns {boolean}
   */
  function isExternalVideo(src) {
    let isFromService = false;

    videoservices.forEach(service => {
      if(src.includes(service)) {
        isFromService = true;
      }
    });
    return isFromService;
  }

  /**
   * Hide the iframe and block its src
   * @param {HTMLElement} iframe iframe to hide
   */
  function hideIframe(iframe) {
    iframe.setAttribute('data-cookieblock-src', iframe.src);
    iframe.setAttribute('src', '');
    iframe.setAttribute('data-cookieconsent', 'marketing, statistics, preferences');

    //hide the iframe based on cookiebot settings
    const videoParent = iframe.closest('.js-video-element');
    if(videoParent) {
      videoParent.classList.add('cookieconsent-optin-marketing','cookieconsent-optin-statistics','cookieconsent-optin-preferences');
    } else {
      iframe.classList.add('cookieconsent-optin-marketing','cookieconsent-optin-statistics','cookieconsent-optin-preferences');
    }
  }

  //Go through page iframes
  if(iframeELems.length) {
    iframeELems?.forEach(iframe => {
      if(isExternalVideo(iframe.src)) {
        hideIframe(iframe);
      }
    });

  }
}
